import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';

@Injectable({
   providedIn: 'root'
})

export class CanonicalService {
   constructor(
      private router: Router,
      @Inject(DOCUMENT) private readonly dom: Document) { }
   createCanonicalURL(value:any) {
    //sandbox
      // let baseUrl = "https://buytrucknbus-ospdev.home.tatamotors" //3000
      // let baseUrl = "https://buytrucknbus-osp3dev.home.tatamotors" //5000
      // let baseUrl = "https://buytrucknbus-osp3qa.home.tatamotors" //8000
      // let baseUrl = "https://buytrucknbus-staging.home.tatamotors" //9000
    //production
      // let baseUrl = "https://fleetverse.tatamotors.com"  //4000
      let baseUrl = "https://fleetverse.tatamotors.com"  //4000
      let url = value ? (baseUrl + '/' + value) : (baseUrl + this.router.url)
      const canonicalUrl = url;
      const head = this.dom.getElementsByTagName('head')[0];
      var element: HTMLLinkElement = this.dom.querySelector(`link[rel='canonical']`) || null;
      if (element == null) {
         element = this.dom.createElement('link') as HTMLLinkElement;
         head.appendChild(element);
      }
      element.setAttribute('rel', 'canonical');
      element.setAttribute('id', 'canonicalURL');
      element.setAttribute('href', canonicalUrl);
      console.log('Generated Canonical URL', canonicalUrl)
   }

}
